import React from "react";
import { Link } from "react-router-dom";

interface FAQCardProps {
  heading: string;
  Questions: string[];
  linkTo: string;
}

const FAQCard: React.FC<FAQCardProps> = ({ heading, Questions, linkTo }) => {
  return (
    <div className="group col-span-1 bg-white border border-neutralGray hover:bg-customDivColor hover:border-none hover:scale-105 transition-all duration-300 shadow-lg rounded-2xl flex flex-col p-6 h-full">
      <div className="flex-1">
        <p className="font-helveticaBold text-black text-xl md:text-lg">
          {heading}
        </p>
        <div className="flex flex-col mt-3 space-y-2 font-helveticaMedium text-base text-gray-600 group-hover:text-customGrayDark tracking-tight">
          {Questions.map((question, index) => (
            <p key={index}>{question}</p>
          ))}
        </div>
      </div>

      <Link
        to={linkTo}
        className="bg-transparent w-max transition-colors duration-300 border border-neutralGray text-black font-helveticaMedium group-hover:bg-greenButtonColor text-sm px-4 py-2 group-hover:text-white rounded-lg mt-6"
      >
        Find Answers
      </Link>
    </div>
  );
};
export default FAQCard;
